import { Table } from "antd";
import TableAntd from "components/elements/Table/Table";
import { useTranslation } from "react-i18next";

const MyTeamTimestampTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: <div className="text-table">Employee</div>,
      dataIndex: "employee",
      key: "employee",
    },
    {
      title: <div className="text-table">Shift</div>,
      dataIndex: "late",
      key: "late",
    },
    {
      title: <div className="text-table">1st time</div>,
      dataIndex: "firstTime",
      key: "firstTime",
    },
    {
      title: <div className="text-table">2nd time</div>,
      dataIndex: "secondTime",
      key: "secondTime",
    },
    {
      title: <div className="text-table">3rd time</div>,
      dataIndex: "thirdTime",
      key: "thirdTime",
    },
    {
      title: <div className="text-table">4th time</div>,
      dataIndex: "fourthTime",
      key: "fourthTime",
    },
    {
      title: <div className="text-table">5th time</div>,
      dataIndex: "fifthTime",
      key: "fifthTime",
    },
    {
      title: <div className="text-table">6th time</div>,
      dataIndex: "sixthTime",
      key: "sixthTime",
    },
    {
      title: <div className="text-table">7th time</div>,
      dataIndex: "seventhTime",
      key: "seventhTime",
    },
  ];

  return (
    <TableAntd
      loading={isLoading}
      dataSource={dataSource}
      columns={columns}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
    />
  );
};

export default MyTeamTimestampTable;
